import React from 'react';
import { ROOMS, ROOM_TYPES } from '../../utils/constants';

/**
 * 会議室情報（閲覧専用）
 */
const RoomInfo = () => {
  const rooms = ROOM_TYPES.map((type) => ROOMS[type]);

  return (
    <div>
      <div className="section-header">
        <h2>会議室情報</h2>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>名称</th>
              <th style={thStyle}>定員</th>
            </tr>
          </thead>
          <tbody>
            {rooms.map((room) => (
              <tr key={room.id}>
                <td style={tdStyle}>{room.id}</td>
                <td style={tdStyle}>{room.name}</td>
                <td style={tdStyle}>{room.capacity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const thStyle = {
  textAlign: 'left',
  padding: '10px 12px',
  backgroundColor: '#f7f7f7',
  borderBottom: '1px solid #e0e0e0',
  color: '#333',
  fontWeight: 600,
};

const tdStyle = {
  padding: '10px 12px',
  borderBottom: '1px solid #eee',
  color: '#444',
};

export default RoomInfo;


